import Enterprise from "./Enterprise";
import "./index.scss";

export default Enterprise;
